<div class ="page">
<app-component-header></app-component-header>

<div class="container content">
    <section class="feature-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 mb-4" style="margin-top: 6rem !important">
                    <div class="text-highlight text-center pt-3">Phát hiện dấu hiệu truy cập bất thường từ thiết bị của bạn<br>Vui lòng thử lại sau !</div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 mb-4">
                    <div class="text-result text-center">
                        <img src="assets/img/error-warning.png" alt="icon" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<app-component-footer></app-component-footer>
</div>